
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/cercador",
      function () {
        return require("private-next-pages/3cat/cercador/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/cercador"])
      });
    }
  